import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/lots.js';
import form from '../forms/lots.js';
import * as types from '../types.js';

const lots = function()
{

	let lots_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_products, this.queryAll()).then((data) => db.set('products', data).catch(error => notify(error)));
			api.call(api.list_programs, this.queryAll()).then((data) => db.set('programs', data).catch(() => {}));
		},
		async queryData(query)
		{
			return await api.call(api.list_lots, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_lot, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				input_id: Number(data.input_id),
				product_id: Number(data.product_id),
				lot_number: data.lot_number,
				serial: (data.serial && String(data.serial).trim()) ? String(data.serial).trim().slice(0, 20) : null,
				manufacture_date: data.manufacture_date,
				expiration_date: data.expiration_date,
				quantity: Number(data.quantity),
				status: Number(data.status),
			};
			if (old_data)
				return await api.call(api.update_lot, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_lot, data.company_id, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Lote', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do lote' },
		{ index: 3, field: 'input_id', label: 'Entrada', types: [types.number(0, 2)], placeholder: '0', title: 'Número da entrada de lote' },
		{ index: 4, field: 'product_id', label: 'Produto', types: [types.datalist()], placeholder: '', title: 'Produto', store: 'products', labels: ['name'] },
		{ index: 5, field: 'program_id', label: 'Programa', types: [types.datalist()], placeholder: '', title: 'Programa (somente leitura)', store: 'programs', labels: ['name'], readOnly: true },
		{ index: 6, field: 'lot_number', label: 'Numeração', types: [], placeholder: '', title: 'Numeração do lote' },
		{ index: 7, field: 'serial', label: 'Serial', types: [], placeholder: '', title: 'Serial opcional do lote (até 20 caracteres)' },
		{ index: 8, field: 'manufacture_date', label: 'Fabricação', types: [types.date()], placeholder: 'dd/mm/aaaa', title: 'Data de fabricação do lote' },
		{ index: 9, field: 'expiration_date', label: 'Validade', types: [types.date()], placeholder: 'dd/mm/aaaa', title: 'Data de validade do lote' },
		{ index: 10, field: 'quantity', label: 'Quantidade', types: [types.number(0, 2)], placeholder: '0', title: 'Quantidade do lote' },
		{ index: 11, field: 'status', label: 'Status', types: [types.opt_lot_status(), types.datalist()], placeholder: '', title: 'Status do lote' },
		{ index: 13, field: 'location_address', label: 'Endereço', types: [], placeholder: '', title: 'Endereço da posição (estoque) — ex.: 1-a-1-1; várias posições separadas por |' },
	];

	lots_crud.run(
		'lots',
		'Lotes',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		undefined,
		undefined,
		{ default_columns: '1,2,3,4,5,6,7,8,9,10,12' },
	);

};

export default lots;

